






























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class WorkExp extends Vue {
  @Prop() private company!: String;
  @Prop() private companyUrl!: String;
  @Prop() private jobTitle!: String;
  @Prop() private startDate!: Date;
  @Prop() private endDate!: Date;
  @Prop() private techSkills!: String[];
  @Prop() private nonTechSkills!: String[];
}
